<template>
  <div>
    <template v-if="showOnly">
      <span v-if="dialog.status !== 1" class="badge badge-primary">{{ statuses[dialog.status]?.title }}</span>
    </template>
    <template v-else>
      <label class="text-muted">Статус диалога</label>
      <div class="input-group">
        <select v-model="dialog.status" class="form-control">
          <option v-for="s in statuses" :value="s.id">{{ s.title }}</option>
        </select>
        <div v-if="+dialog.status === 6">
          <input type="text" v-model="dialog.chat_data.status_comment" class="form-control" placeholder="Страна">
        </div>
        <div class="input-group-append">
          <LoadingButton
            title="Сохранить"
            type="button"
            :loading="loading"
            :color="$constants.LOADING_COLOR"
            :onClick="() => updateStatus()"
            className="btn btn-outline-info"
          />
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import LoadingButton from "@/components/buttons/LoadingButton.vue";
import api from "@/api";

export default {
  components: {LoadingButton},
  props: ['dialog', 'onUpdate', 'showOnly', 'drug', 'cityId'],
  data() {
    return {
      loading: false,
      statuses: {
        1: {id: 1, title: 'открытый чат'},
        2: {id: 2, title: 'думает/консультация'},
        3: {id: 3, title: 'оформлена заявка'},
        4: {id: 4, title: 'верификация заказа'},
        5: {id: 5, title: 'нет препарата'},
        6: {id: 6, title: 'нет доставки (страна)'},
      }
    }
  },
  created() {
    if (!this.dialog.chat_data) this.dialog.chat_data = {};
    if (!this.dialog.chat_data.status_comment) this.dialog.chat_data.status_comment = null;
  },
  methods: {
    async updateStatus() {
      this.loading = true;
      if (+this.dialog.status === 5 && !this.drug?.id) {
        toastr['warning']('Укажите препарат', 'Ошибка!');
        return;
      }
      if (+this.dialog.status === 6 && !this.dialog.chat_data.status_comment) {
        toastr['warning']('Укажите страну доставки', 'Ошибка!');
        return;
      }
      const {data} = await api.post('/clientChats/chat/' + this.dialog.id, {
        action: 'updateStatus',
        new_status: this.dialog.status,
        project_id: this.dialog?.bot?.project_id,
        drug_id: this.drug?.id,
        drug_title: this.drug?.title,
        city_id: this.cityId
      });
      if (data.success) {
        toastr['success']('Сохранено', 'Успешно!');
        if (this.onUpdate) this.onUpdate();
      } else {
        toastr['warning'](data.message ?? 'Ошибка сервера', 'Ошибка!');
      }
      this.loading = false;

    }
  }
}

</script>
